import { render, staticRenderFns } from "./VenueShortListDetailed.vue?vue&type=template&id=3c6b4ce3&"
import script from "./VenueShortListDetailed.vue?vue&type=script&lang=js&"
export * from "./VenueShortListDetailed.vue?vue&type=script&lang=js&"
import style0 from "./VenueShortListDetailed.vue?vue&type=style&index=0&id=3c6b4ce3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports